/**
 * 将剩余分钟数转换为剩余天数
 *
 * @param remainMinutes - 剩余的分钟数，可选参数，如果未提供则默认为0
 * @returns 向下取整后的天数（1天 = 1440分钟 = 24小时）
 */
export const formatRemainDay = (remainMinutes?: number) => {
  return Math.floor((remainMinutes ?? 0) / 1440);
};
